export const LanguageOptions = [
    {
        label : "English",
        value : "en"
    },
    {
        label : "Spanish",
        value : "es"
    },
    {
        label : "French",
        value : "fr"
    },
    {
        label : "German",
        value : "de"
    },
    {
        label : "Japanese",
        value : "ja"
    },
    {
        label : "Chinese",
        value : "zh-CN"
    },
    {
        label : "Italian",
        value : "it"
    },
    {
        label : "Portuguese",
        value : "pt"
    },
    {
        label : "Russian",
        value : "ru"
    },
];

export const colorsList = [
    {
        label : "Default",
        value : "default",
        color : "#034737"
    },
    {
        label : "Purple",
        value : "purple",
        color : "#a020f0"
    },
    {
        label : "Blue",
        value : "blue",
        color: "#004cff"
    },
    {
        label : "Pink",
        value : "pink",
        color: "#ff1493"
    },
    /* {
        label : "Violet",
        value : "violet",
        color: "#ee82ee"
    }, */
    {
        label : "Indigo",
        value : "indigo",
        color: "#4b0082"
    },
    /* {
        label : "Orange",
        value : "orange",
        color: "#ff8c00"
    },
    {
        label : "Teal",
        value : "teal",
        color: "#008080"
    },
    /* {
        label : "Bronze",
        value : "bronze",
        color: "#cd7f32"
    },
    {
        label : "Mint",
        value : "mint",
        color: "#3eb489"
    }, */
];